// Very subtle botanical decorations scattered down the Maker pages — sits behind
// the imagery (z-[1]) so it only whispers through the margins and gaps.
const G = "/maker/graphics";
const FLORA = [
  { img: "fern", cls: "top-[4%] -left-8 w-24 md:w-40 rotate-[10deg]", o: "opacity-[0.16]" },
  { img: "branch", cls: "top-[12%] -right-6 w-28 md:w-48 -rotate-6", o: "opacity-[0.13]" },
  { img: "wildflowers", cls: "top-[22%] left-[1%] w-20 md:w-32 -rotate-[12deg]", o: "opacity-[0.15]" },
  { img: "twig", cls: "top-[31%] -right-8 w-32 md:w-52 rotate-[5deg]", o: "opacity-[0.12]" },
  { img: "petals", cls: "top-[40%] left-[5%] w-16 md:w-28 rotate-[16deg]", o: "opacity-[0.16]" },
  { img: "fern", cls: "top-[49%] -right-6 w-24 md:w-40 -rotate-[16deg] scale-x-[-1]", o: "opacity-[0.13]" },
  { img: "wildflowers", cls: "top-[58%] -left-6 w-24 md:w-36 rotate-[8deg]", o: "opacity-[0.15]" },
  { img: "branch", cls: "top-[67%] right-[2%] w-24 md:w-40 rotate-[4deg] scale-x-[-1]", o: "opacity-[0.12]" },
  { img: "petals", cls: "top-[76%] left-[3%] w-16 md:w-24 -rotate-[10deg]", o: "opacity-[0.15]" },
  { img: "twig", cls: "top-[85%] -right-8 w-28 md:w-48 -rotate-[7deg] scale-x-[-1]", o: "opacity-[0.12]" },
  { img: "fern", cls: "top-[93%] left-[1%] w-20 md:w-36 rotate-[12deg]", o: "opacity-[0.14]" },
];

export default function GardenFlora() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-[1] overflow-hidden">
      {FLORA.map((f, i) => (
        <img
          key={i}
          src={`${G}/${f.img}.png`}
          alt=""
          className={`absolute select-none ${f.cls} ${f.o}`}
        />
      ))}
    </div>
  );
}
